export enum DebitorsPermissions {
  VIEW_DEBTOR_TYPE = "view_debtor_type",
  CREATE_DEBTOR_TYPE = "create_debtor_type",
  UPDATE_DEBTOR_TYPE = "update_debtor_type",
  DELETE_DEBTOR_TYPE = "delete_debtor_type",
  ARCHIVE_DEBTOR_TYPE = "archive_debtor_type",
}

export const DebitorsPermissionsText: Record<DebitorsPermissions, string> = {
  [DebitorsPermissions.VIEW_DEBTOR_TYPE]: "View Debtor Type",
  [DebitorsPermissions.CREATE_DEBTOR_TYPE]: "Create Debtor Type",
  [DebitorsPermissions.UPDATE_DEBTOR_TYPE]: "Update Debtor Type",
  [DebitorsPermissions.DELETE_DEBTOR_TYPE]: "Delete Debtor Type",
  [DebitorsPermissions.ARCHIVE_DEBTOR_TYPE]: "Archive Debtor Type",
};
